module.exports = __webpack_public_path__ + "img/play_color.bafb5bb1.svg";